// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__t4uV4","spinner":"Spinner_spinner__XeVz9","animation":"Spinner_animation__ziwbV"};